module.exports = __webpack_public_path__ + "static/img/contentBg.ad0edfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/contentBg.png
// module id = lRjK
// module chunks = 1